import Error404 from "@/components/error/Error404Component";

export default [
	{
		path : '/:pathMatch(.*)*',
		name : 'error_404',
		meta : { layout: "error",  title: 'Error 404', auth: false },
		component : Error404
	},
];